import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '../api/baseApi';
import authReducer from '../features/auth/authSlice';
import detailPanelReducer from '../features/ui/detailPanelSlice';
import { rtkQueryErrorLogger } from './errorMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    detailPanel: detailPanelReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefault) => getDefault().concat(baseApi.middleware, rtkQueryErrorLogger),
  devTools: process.env.NODE_ENV !== 'production',
});

setupListeners(store.dispatch);
